<template>
  <form class="building-form">
    <div class="input-group-lg">
      <div v-if="isFirstBuilding" class="pb-1">
        <input type="checkbox" id="copy-mailing" v-model="isCopyAddress">
        <label
          for="copy-mailing" class="ml-2"
          :class="buildingDetails.attributes.copyMailingAddress.class"
        >
          {{ buildingDetails.attributes.copyMailingAddress.text }}
        </label>
      </div>

      <validation-observer
        tag="form"
        @submit.prevent="createBuilding()"
        ref="buildingDetails"
      >
        <form-field
          :formFields="fields"
          :show="true"
          :model="currentBuildingWithExtraInfo"
          :id-prefix="idPrefix"
          :isCopyAddress="isCopyAddress"
          :isFulFillSyncAllowed="fulfilSynDetails?.allowed"
        />


        <!-- Button Container for Side-by-Side Layout -->
        <div class="d-flex justify-content-center mt-3">
          <button
            type="button"
            class="btn btn-lg mr-2"
            :class="cancelButtonClass"
            @click="redirectBack(cancelButtonPath)"
          >
            {{ cancelButtonText }}
          </button>

          <button
            type="submit"
            :disabled="awaitingResponse"
            class="btn btn-lg ml-2"
            :class="buildingDetails.attributes[selectedButton].class"
            v-if="!disable_edit_building"
          >
            {{ buildingDetails.attributes[selectedButton].text }}
          </button>
        </div>

      </validation-observer>
    </div>
  </form>
</template>

<script>
import FormField from './form/FormField.vue';
import router from '../router/index';
import debounce from "@popperjs/core/lib/utils/debounce";

export default {
  name: 'BuildingFormFields',

  components: {
    FormField,
  },

  props: {
    selectedButton: {
      type: String,
      default: 'button2',
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      idPrefix: 'building-details',
      isCopyAddress: false,
      currentBuildingWithExtraInfo: {},
      awaitingResponse: false,
    };
  },

  created() {
    this.updateBuildingData();
  },

  computed: {
    buildingDetails() {
      return this.$store.state.partners.currentPartner.settings.sections?.building_details || {};
    },

    cancelButtonText() {
      return this.buildingDetails?.attributes?.button_cancel?.text || 'Cancel';
    },

    cancelButtonClass() {
      return this.buildingDetails?.attributes?.button_cancel?.class || ['btn-egx-white'];
    },

    cancelButtonPath() {
      return this.buildingDetails?.attributes?.button_cancel?.path || 'buildings-list';
    },

    currentBuilding() {
      return this.$store.state.buildings.currentBuilding;
    },

    isFirstBuilding() {
      return this.currentBuilding.id === null
        && this.$store.state.buildings.allBuilding.length === 0;
    },
    partner() {
      return this.$store.state.partners.currentPartner;
    },

    disable_edit_building() {
      const disable = this.partner.settings.disable_building_profile_edition;
      return disable || !this.isEditable;
    },
    fields() {
      if (this.disable_edit_building) {
        return this.buildingDetails.fields.map((field) => (
          {
            ...field,
            disabled: 'true',
          }
        ));
      }
      return this.buildingDetails.fields;
    },

    fulfilSynDetails() {
      return this.partner.settings.fulfill_sync_details;
    },
  },

  methods: {
    createBuilding() {
      if (!this.disable_edit_building) {
        this.$refs.buildingDetails.validate()
          .then((isValid) => {
            if (isValid) {
              // disable submit button while request resolves
              this.awaitingResponse = true;

              this.$store.dispatch('buildings/update', this.currentBuildingWithExtraInfo)
                .then((response) => {
                  this.$store.dispatch('users/updateCsvBuildingId');
                  this.$emit('update-success');
                })
                .catch((error) => {
                  if (error.response) {
                    console.log(error.response.data.errors);

                    this.$notify({
                      group: 'notice-stay',
                      type: 'error',
                      text: error.response.data.errors[0].title,
                    });
                  }
                  // re-enable submit button
                  this.awaitingResponse = false;
                });
            } else {
              this.$notify({
                group: 'notice-stay',
                type: 'error',
                text: 'Fill in all required fields.',
              });
            }
          });
      } else {
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: 'Building update is disabled.',
        });
      }
    },

    updateBuildingData() {
      this.currentBuildingWithExtraInfo = {
        ...this.currentBuilding,
        ...this.currentBuilding.extra_info,
      };
    },
    redirectBack(name) {
      router.push({ name });
    },
    goBackToBuildingsList() {
      this.redirectBack('buildings-list');
    },
  },
};
</script>
